module.exports = __webpack_public_path__ + "img/47-21-floor.a04366cf.jpg";